// A warehouse query cell's body: the chat's query card, starting from the
// person's saved edit. Run and "Save as query" are the card's own (the same
// route and the same owner-and-Manager rule as in the chat); an edit to the
// SQL is also kept in the Notebook, for "Send changes to the agent".
//
// Like WarehouseQueryCardContainer, this joins the card to its networking hook.
import React from 'react'
import { WarehouseQueryCard } from '../WarehouseQueryCard'
import useWarehouseQueryCard from '../useWarehouseQueryCard'
import { warehouseEventFromData } from '../warehouseQueryTypes'
import type { NotebookCell } from './notebookTypes'

export interface NotebookQueryCellProps {
  cell: NotebookCell
  customer: string | undefined
  sessionId: string
  /** Why the viewer may not run or save this query (the card's rule). */
  actionReason?: string
  onSqlChange: (sql: string) => void
}

export const NotebookQueryCell: React.FC<NotebookQueryCellProps> = ({ cell, customer, sessionId, actionReason, onSqlChange }) => {
  const event = warehouseEventFromData(cell.data, cell.id)!
  const card = useWarehouseQueryCard({ customer, sessionId, event, initialSql: cell.edit?.sql })

  const handleSqlChange = (sql: string) => {
    card.setSql(sql)
    onSqlChange(sql)
  }

  return (
    <WarehouseQueryCard
      event={event}
      view={card.view}
      sql={card.sql}
      onSqlChange={handleSqlChange}
      actionReason={actionReason}
      running={card.running}
      runError={card.runError}
      onRun={card.handleRun}
      composerReason="Use Send changes to the agent at the top of the Notebook."
      onUseVersion={() => {}}
      saving={card.saving}
      saveError={card.saveError}
      savedName={card.savedName}
      onSave={card.handleSave}
    />
  )
}

export default NotebookQueryCell
